import React, { ReactElement, useState } from 'react';
import { Form, Select } from 'antd';

import useBreedColors from 'pricing/hooks/useBreedColors/useBreedColors';
import { testId } from 'pricing/utilities/test/dataTestId';

interface Props {
  disabled: boolean;
}

function FilterFieldColors(props: Props): ReactElement {
  const { disabled } = props;
  const [breedId, setBreedId] = useState();
  const { breedColors, isBreedColorsLoading } = useBreedColors(breedId);

  return (
    <Form.Item
      noStyle
      shouldUpdate={(prevValues, curValues) => {
        if (prevValues.breed_id !== curValues.breed_id) {
          setBreedId(curValues.breed_id);
        }
        return prevValues.breed_id !== curValues.breed_id;
      }}
    >
      {(form) => {
        const breedId = form.getFieldValue('breed_id');

        return (
          <Form.Item name="color_ids" style={{ width: 200, marginBottom: 0 }}>
            <Select
              disabled={!breedId || isBreedColorsLoading || disabled}
              data-testid={testId.filterFieldPuppyColors}
              placeholder="Color"
              loading={isBreedColorsLoading}
              allowClear
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {breedColors
                ?.filter((c) => c.id !== 0)
                ?.map((color) => (
                  <Select.Option
                    data-testid={testId.filterFieldPuppyColorOption}
                    key={color.id}
                    value={color.id}
                  >
                    {color.name}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
        );
      }}
    </Form.Item>
  );
}

export default FilterFieldColors;
